module.exports = __webpack_public_path__ + "img/gear-I-high_82x82.3f2727c7.png";